import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateImageResponse } from '@responses/images';
import axios from 'axios';

import { getCurrentDocumentApiUrl } from './getCurrentDocumentApiUrl';

const IMAGES_URI = 'images';

export const getImagesPresignedUrl = async (
  fileName: string,
  size: number,
  type: string,
  templateId?: string,
  submissionId?: string,
  endorsementId?: string,
): Promise<CreateImageResponse | undefined> => {
  const url = [getCurrentDocumentApiUrl(templateId, submissionId, endorsementId), IMAGES_URI].join('/');
  if (!url) {
    return undefined;
  }

  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url,
    data: {
      fileName,
      size,
      type,
    },
  });

  const response = await axios(networkPayload);
  return response.data;
};
